import { AttribCodeDialogProps } from "@interfaces/slices";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";

import WarningCheck from "@assets/download_warning_icon.svg";

interface CodigosAtribucion extends AttribCodeDialogProps {
    onBackClick: () => void;
    onConfirmClick: () => void;
}

export const CodigoAtribucion = (props: CodigosAtribucion) => {
    return (
        <Box sx={{
            margin: 4
        }}>
            <Stack
                sx={{
                    textAlign: "center",
                    mb: 2
                }}>
                {props.bulkUpload === true && (
                    <img src={WarningCheck} height={"65px"} style={{ marginBottom: "10px" }} />
                )}
                <Typography component={"span"} sx={{
                    color: "main3",
                    fontWeight: 600
                }}>
                    Está seguro que quiere{" "}
                    {props.register ? (
                        <Typography component={"span"} sx={{
                            color: "secondary4",
                            fontWeight: 600
                        }}>
                            dar de alta
                        </Typography>
                    ) : (
                        <Typography component={"span"} sx={{
                            color: "secondary4",
                            fontWeight: 600
                        }}>
                            dar de baja
                        </Typography>
                    )}{" "}
                    {props.bulkUpload === true ? "de manera másiva" : "a:"}
                </Typography>
                {props.bulkUpload !== true && (
                    <>
                        <Typography
                            sx={{
                                color: "main2",
                                fontWeight: 600,
                                mt: 2
                            }}>
                            {props.data?.businessName}
                        </Typography>
                        <Typography sx={{ color: "main2" }}>Código: {props.data?.attributionCode}</Typography>
                    </>
                )}
            </Stack>
            {props.data !== undefined && (
                <Grid container>
                    <Grid size={3}>
                        <Typography sx={{
                            color: "main3",
                            fontWeight: 400
                        }}>
                            Source:
                        </Typography>
                    </Grid>
                    <Grid size={8}>
                        <Typography sx={{ color: "main2" }}>{props.data.source}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{
                            color: "main3",
                            fontWeight: 400
                        }}>
                            Medium:
                        </Typography>
                    </Grid>
                    <Grid size={8}>
                        <Typography sx={{ color: "main2" }}>{props.data.medium}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{
                            color: "main3",
                            fontWeight: 400
                        }}>
                            Región:
                        </Typography>
                    </Grid>
                    <Grid size={8}>
                        <Typography sx={{ color: "main2" }}>{props.data.region}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{
                            color: "main3",
                            fontWeight: 400
                        }}>
                            Colaborador:
                        </Typography>
                    </Grid>
                    <Grid size={8}>
                        <Typography sx={{ color: "main2" }}>{props.data.partnership}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{
                            color: "main3",
                            fontWeight: 400
                        }}>
                            Correo:
                        </Typography>
                    </Grid>
                    <Grid size={8}>
                        <Typography sx={{ color: "main2" }}>{props.data.email}</Typography>
                    </Grid>
                    <Grid size={3}>
                        <Typography sx={{
                            color: "main3",
                            fontWeight: 400
                        }}>
                            Teléfono:
                        </Typography>
                    </Grid>
                    <Grid size={8}>
                        <Typography sx={{ color: "main2" }}>{props.data.phone}</Typography>
                    </Grid>
                </Grid>
            )}
            <Stack
                direction={"row"}
                sx={{
                    justifyContent: "space-around",
                    mt: 4
                }}>
                <Button variant="blue_outlined" size={"large"} onClick={props.onBackClick}>
                    Cancelar
                </Button>
                <Button variant="contained" color="secondary4" size={"large"} onClick={props.onConfirmClick}>
                    {props.bulkUpload ? "Aceptar" : "Autorizar"}
                </Button>
            </Stack>
        </Box>
    );
};
